import React from 'react';

const CircleIcon = ({ width = 24, height = 24 }) => (
  <div style={{ display: 'inline-block', width, height }}>
    <img src="/logos/circle.svg" alt="Circle" style={{ width, height, objectFit: 'contain' }} />
  </div>
);

export default CircleIcon;
